(function () {
  async function syncTitle() {
    const res = await fetch(location.href, { headers: { Accept: 'text/html' } });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (doc.title) document.title = doc.title;
  }

  const origReplace = history.replaceState;
  history.replaceState = function (...args) {
    origReplace.apply(this, args);
    syncTitle();
  };
})();